module.exports = __webpack_public_path__ + "img/thethao.119976af.jpg";